{
  "title": "VIP Cashback",
  "yourLevel": "САТҲИ ШУМО",
  "completed": "АНҶОМ ШУД",
  "locked": "БАСТ",
  "xpLabel": "Таҷриба",
  "xpRule": "Ҳисоби таҷриба: €1 шарт = {{xp}} холҳои таҷриба",
  "cashback": "Кешбек {{pct}}%",
  "cashbackMax": "Кешбек {{lo}}% - {{hi}}%",
  "daily": "Ҳар рӯз",
  "everyDays": "Ҳар {{days}} рӯз як бор",
  "active": "Фаъол: AZN {{amount}}",
  "claim": "ГИРИФТАН",
  "howTitle": "Ин чӣ гуна кор мекунад?",
  "how1": "Слот ва бозиҳои дӯстдоштаатонро бозӣ кунед",
  "how2": "Таҷриба гиред ва сатҳро баланд кунед",
  "how3": "Кешбек ва мукофот гиред",
  "lockedNote": "Барои «{{name}}» таҷрибаи бештар лозим аст",
  "loginHint": "Барои XP, кешбек ва гирифтан ворид шавед",
  "login": "Воридшавӣ",
  "history": "Таърих",
  "historyEmpty": "Ҳанӯз сабт нест.",
  "claimTitle": "Кешбек гирифтан",
  "claimAmount": "Маблағ: {{amount}} AZN",
  "claimNote": "Мустақим ба баланси воқеӣ. Wagering: 0x.",
  "cancel": "Бекор",
  "confirm": "Тасдиқ",
  "congrats": "Табрик!",
  "newLevel": "Сатҳи нави VIP: {{name}}",
  "continue": "Идома",
  "infoBody": "Танҳо шартҳои казинои пули воқеӣ XP ва кешбек медиҳанд. Бонус, варзиш ва демо дохил нестанд. Интизории 24 соат ва мин 1 AZN.",
  "close": "Пӯшидан",
  "maxNote": "VIP MAX — XP қатъ. Кешбеки гардиши категория.",
  "level_1": "Мис",
  "level_2": "Биринҷӣ",
  "level_3": "Нуқра",
  "level_4": "Тилло",
  "level_5": "Ёқут",
  "level_6": "Сафир",
  "level_7": "Алмос",
  "level_8": "VIP MAX",
  "maintenance": "Таътил — гирифтан муваққатан баста аст.",
  "rulesTitle": "QAYDALAR",
  "rulesIntro": "“VIP Cashback” Kazinosuna xoş gəlmisiniz! Sistem səviyyənizə, oyun növlərinə və mərc müntəzəmliyinə görə real pulun bir hissəsini geri almaq imkanı verir. Nə qədər aktiv oynasanız, bir o qədər tez-tez və daha çox keşbek əldə edirsiniz.",
  "rulesWhatTitle": "VIP Cashback nədir",
  "rulesWhat": "Keşbek — oyun aktivliyinə görə xərclənmiş vəsaitin bir hissəsinin geri qaytarılmasıdır. Dinamikdir və səviyyəniz yüksəldikcə dəyişir.",
  "rulesLevelsTitle": "Cashback səviyyələri",
  "rulesLevels1": "Sistemdə 8 səviyyə var. Növbəti səviyyəyə keçmək üçün təcrübə xalı toplamaq lazımdır.",
  "rulesLevels2": "Yeni səviyyə keşbek faizini və götürmə tezliyini artırır.",
  "rulesXpTitle": "Təcrübə xalının hesablanması",
  "rulesXpNote": "Hər səviyyədə €1 mərc = müvafiq XP. Saytda balans və keşbek AZN-dir; XP əmsalları eyni qaydada tətbiq olunur (1 AZN mərc = eyni XP).",
  "rulesCbTitle": "Cashback necə işləyir",
  "rulesCb1": "1–7 səviyyələrdə (Mis–Almaz) keşbek uduzulmuş mərclərə görə hesablanır.",
  "rulesCbFormula": "Keşbek = (Mərclərin cəmi − Qazanılan məbləğ) × keşbek %",
  "rulesCb2": "Dövr üzrə nəticə müsbətdirsə, keşbek 0 olur.",
  "rulesCb3": "VIP MAX-da keşbek hər real mərcə görə kateqoriya faizi ilə verilir: Slot 0.25%, Lotereya 0.20%, Canlı kazino 0.10%, Masa oyunları 0.05%.",
  "rulesImportantTitle": "Bilmək vacibdir",
  "rulesImportant1": "Bonus balanslı, idman və demo mərclər XP/keşbek yaratmır.",
  "rulesImportant2": "24 saat gözləmə və minimum 1 AZN götürmə qaydası qüvvədədir.",
  "rulesImportant3": "Keşbek birbaşa real balansa köçürülür (0x wagering).",
  "rulesXp1": "1-ci səviyyə “Mis”: Hər €1 mərc üçün oyunçu 100 təcrübə xalı alır",
  "rulesXp2": "2-ci səviyyə “Bürünc”: Hər €1 mərc üçün oyunçu 150 təcrübə xalı alır",
  "rulesXp3": "3-ci səviyyə “Gümüş”: Hər €1 mərc üçün oyunçu 200 təcrübə xalı alır",
  "rulesXp4": "4-ci səviyyə “Qızıl”: Hər €1 mərc üçün oyunçu 250 təcrübə xalı alır",
  "rulesXp5": "5-ci səviyyə “Yaqut”: Hər €1 mərc üçün oyunçu 300 təcrübə xalı alır",
  "rulesXp6": "6-ci səviyyə “Safir”: Hər €1 mərc üçün oyunçu 350 təcrübə xalı alır",
  "rulesXp7": "7-ci səviyyə “Almaz”: Hər €1 mərc üçün oyunçu 400 təcrübə xalı alır",
  "rulesXp8": "8-ci səviyyə “VIP MAX”: sonuncu səviyyə, təcrübə xalı verilmir",
  "lockedShort": "БАСТ"
}
